.conflict {
	color: var(--color-error-foreground);
	background-color: var(--color-error-background);
}

.votes {
	margin: 0;
	padding: 0;
	list-style: none;
}
